import { RootState } from '../store'

export const getLicense = (state: RootState) => state.license
